<template>
  <div class="event-participants-filter">
    <bp-select
      v-model="checkIn"
      label="Check-in"
      class="mb-6"
      placeholder="Selecionar o estado do checkIn"
      :options="checkInOptions"
    />

    <div class="d-flex flex-column flex-lg-row justify-content-lg-end">
      <button class="btn btn-primary order-lg-1 px-6 btn-40" @click="apply">
        Aplicar
      </button>
      <button
        class="btn btn-new-secondary px-6 btn-40 mr-lg-5 mt-5 mt-lg-0"
        @click="$emit('close')"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      checkIn: this.getCheckIn(),
      checkInOptions: [
        { id: "all", name: "Todos" },
        { id: "done", name: "Realizado" },
        { id: "pending", name: "Pendente" }
      ]
    };
  },
  methods: {
    apply() {
      const mapCheckin = {
        all: "",
        pending: false,
        done: true
      };

      this.$emit("apply", { checkin_done: mapCheckin[this.checkIn] });
      this.$emit("close");
    },
    getCheckIn() {
      const checkIn = this.filters.checkin_done;

      if (checkIn === false) return "pending";
      else if (checkIn === true) return "done";
      return "all";
    }
  }
};
</script>
